module.exports = __webpack_public_path__ + "static/media/org-suspend.f9876372.svg";